import React from "react";
var __jsx = React.createElement;
import { get } from "lodash";
import { getFormattedDate, getGender } from "../../utils";
import { format } from "date-fns";
import CustomCheckbox from "./CustomCheckbox";
import { getBorderStyle, getBorderClasses, getTextClasses } from "../../utils/colorUtils";
import { t } from "i18next";
import Link from "next/link";
import { useMemo } from "react";
import { useStoreState } from "pullstate";
import ReminderCountBadge from "../../components/PatientReminder/ReminderCountBadge";
import { getOldestReminderByDate } from "../../components/PatientReminder/getOldestReminderByDate";
import { SORT_BY_MAP } from "../../components/Worklist/SortControl";
import { formatPatientNameFromTemplate } from "../../utils/formatPatientNameFromTemplate";
import Store from "../../utils/Store";
import classNames from "classnames";
var BulkPatientCard = function BulkPatientCard(_ref) {
  var _getGender, _get;
  var patient = _ref.patient,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    onSelect = _ref.onSelect,
    worklistColumns = _ref.worklistColumns,
    gridStyle = _ref.gridStyle,
    timestampType = _ref.timestampType,
    isLC = _ref.isLC;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        workspaceConfig: s.workspaceConfig
      };
    }),
    workspaceConfig = _useStoreState.workspaceConfig;
  var patientCardDisplayName = useMemo(function () {
    var _patient$name, _workspaceConfig$data, _workspaceConfig$data2;
    var legacyName = (_patient$name = patient === null || patient === void 0 ? void 0 : patient.name) !== null && _patient$name !== void 0 ? _patient$name : "";
    if (!isLC) {
      return legacyName;
    }
    var patientFirst = String(get(patient, ["additional", "patient_name", "first"], "") || "").trim();
    if (!patientFirst) {
      return legacyName;
    }
    var nameFormat = (_workspaceConfig$data = workspaceConfig === null || workspaceConfig === void 0 || (_workspaceConfig$data2 = workspaceConfig.data) === null || _workspaceConfig$data2 === void 0 || (_workspaceConfig$data2 = _workspaceConfig$data2.ui_settings) === null || _workspaceConfig$data2 === void 0 ? void 0 : _workspaceConfig$data2.name_format) !== null && _workspaceConfig$data !== void 0 ? _workspaceConfig$data : undefined;
    if (!nameFormat) {
      return legacyName;
    }
    return formatPatientNameFromTemplate(nameFormat, get(patient, ["additional", "patient_name"]));
  }, [isLC, patient, workspaceConfig]);

  // Determine which timestamp to display based on the selected type
  var timestampValue = timestampType === SORT_BY_MAP.updated_at ? get(patient, ["last_activity_at"], "") : get(patient, ["created_at"], "");
  var displayDate = getFormattedDate(timestampValue, "PP hh:mm a");
  var uploadSource = get(patient, ["site"], "");
  var patientUid = get(patient, ["patient_uid"], "");
  var hasUnreadMessages = get(patient, ["has_unread_message"], false);
  var getUnreadMessageStatus = function getUnreadMessageStatus() {
    if (!!hasUnreadMessages && !selected) {
      return /*#__PURE__*/React.createElement("div", {
        title: t("message_type.unread_message")
      }, /*#__PURE__*/React.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        className: classNames("fill-teal-300 sm:fill-gray-700 sm:dark:fill-gray-200"),
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5191 3.12671H5.18764C3.98273 3.12671 3 4.16252 3 5.4001V15.7438C3 17.0138 3.98273 18.0172 5.18764 18.0172H8.4691V21.0429C8.4691 21.3973 8.84578 21.6031 9.12266 21.3924L13.392 18.0172H18.3142C19.5191 18.0172 20.5018 16.9814 20.5018 15.7438V11.9986H18.8912V15.8087C18.8912 16.1239 18.6433 16.3851 18.3442 16.3851H12.8751L10.1406 18.5468V16.3851H5.2184C4.91931 16.3851 4.67149 16.1239 4.67149 15.8087V5.43252C4.67149 5.11728 4.91931 4.85607 5.2184 4.85607H11.5191V3.12671Z",
        fill: ""
      }), /*#__PURE__*/React.createElement("circle", {
        className: classNames("fill-teal-300 sm:fill-teal-400 group-hover:!fill-teal-300"),
        cx: "17.8395",
        cy: "5.67936",
        r: "3.16031"
      })));
    }
    return null;
  };
  var unreadMessageStatus = getUnreadMessageStatus();
  var oldestReminderByDate = getOldestReminderByDate(patient === null || patient === void 0 ? void 0 : patient.reminders);
  var handleCheckboxClick = function handleCheckboxClick(e) {
    e.stopPropagation();
  };
  var handleCardClick = function handleCardClick() {
    var uid = patientUid === null || patientUid === void 0 ? void 0 : patientUid.toString();
    Store.update(function (s) {
      s.scrollToPatientUid = uid;
    });
  };
  return /*#__PURE__*/React.createElement(Link, {
    href: "/patients/".concat(patientUid),
    shallow: true,
    onClick: handleCardClick,
    className: "grid px-5 py-5 animate-fullWorklist items-center cursor-pointer hover:bg-gray-50 dark:hover:bg-[#1f2834] transition-colors",
    style: gridStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-8",
    onClick: handleCheckboxClick
  }, /*#__PURE__*/React.createElement(CustomCheckbox, {
    checked: selected,
    onChange: function onChange() {
      return onSelect && onSelect(patient);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-800 dark:text-gray-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-base"
  }, displayDate), /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-700 dark:text-white/50 mt-3"
  }, uploadSource))), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 flex items-start gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-6 h-6 flex items-center justify-center flex-shrink-0"
  }, unreadMessageStatus), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-base dark:text-gray-100 text-gray-900 font-semibold break-all"
  }, patientCardDisplayName || "-"), /*#__PURE__*/React.createElement("div", {
    className: "flex text-md text-gray-800 dark:text-white/50 truncate font-normal mt-3"
  }, /*#__PURE__*/React.createElement("div", null, patient === null || patient === void 0 ? void 0 : patient.age, "Y ", (_getGender = getGender(patient === null || patient === void 0 ? void 0 : patient.gender)) === null || _getGender === void 0 ? void 0 : _getGender.shortLabel), /*#__PURE__*/React.createElement("div", {
    title: patient === null || patient === void 0 ? void 0 : patient.patient_id,
    className: "pl-5 break-all whitespace-pre-wrap"
  }, (_get = get(patient, ["patient_id"], "")) === null || _get === void 0 ? void 0 : _get.slice(0, 15))))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-3 gap-3"
  }, /*#__PURE__*/React.createElement(ReminderCountBadge, {
    reminders: patient === null || patient === void 0 ? void 0 : patient.reminders,
    patientUid: patientUid,
    reminderDateFormatted: oldestReminderByDate === null || oldestReminderByDate === void 0 ? void 0 : oldestReminderByDate.remind_after_formatted
  }), oldestReminderByDate !== null && oldestReminderByDate !== void 0 && oldestReminderByDate.remind_after_formatted ? /*#__PURE__*/React.createElement("div", {
    className: "text-base text-gray-700 dark:text-gray-400"
  }, oldestReminderByDate === null || oldestReminderByDate === void 0 ? void 0 : oldestReminderByDate.remind_after_formatted) : null), /*#__PURE__*/React.createElement("div", {
    className: "text-base text-gray-700 dark:text-gray-400 line-clamp-2 break-words min-w-0",
    title: (oldestReminderByDate === null || oldestReminderByDate === void 0 ? void 0 : oldestReminderByDate.context) || undefined
  }, (oldestReminderByDate === null || oldestReminderByDate === void 0 ? void 0 : oldestReminderByDate.context) || "-"), worklistColumns === null || worklistColumns === void 0 ? void 0 : worklistColumns.map(function (section) {
    return /*#__PURE__*/React.createElement("div", {
      key: section.section,
      className: "text-gray-800 dark:text-gray-100"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1"
    }, section.fields.map(function (field) {
      var _patient$custom_tags, _field$properties;
      var value = patient === null || patient === void 0 || (_patient$custom_tags = patient.custom_tags) === null || _patient$custom_tags === void 0 || (_patient$custom_tags = _patient$custom_tags.find(function (tag) {
        return tag.tag_id === field.id;
      })) === null || _patient$custom_tags === void 0 ? void 0 : _patient$custom_tags.response;

      // Skip rendering if no value
      if (value === undefined || value === null || value === "") {
        return null;
      }
      var displayValue = "";
      var fullValue = "";
      if (field.tag_type === "boolean") {
        displayValue = value ? t("yes_key") : t("no_key");
        fullValue = displayValue;
      } else if (field.tag_type === "multi_dropdown") {
        fullValue = Array.isArray(value) ? value.join(", ") : value;
        displayValue = fullValue;
      } else if (field.tag_type === "date" && value) {
        try {
          var formattedDate = format(new Date(value), "MMM dd, yyyy");
          fullValue = formattedDate;
          displayValue = formattedDate;
        } catch (error) {
          fullValue = String(value);
          displayValue = String(value);
        }
      } else {
        fullValue = String(value);
        displayValue = fullValue;
      }

      // Truncate display value to 20 characters if longer
      var shouldTruncate = displayValue.length > 20 || field.tag.length > 30;
      var truncatedValue = shouldTruncate ? displayValue.substring(0, 20) + "..." : displayValue;

      // Get section color from field properties for consistent styling with PatientTags
      var sectionColor = (_field$properties = field.properties) === null || _field$properties === void 0 ? void 0 : _field$properties.sectionColor;
      return /*#__PURE__*/React.createElement("div", {
        key: field.id,
        className: "inline-flex items-center px-3 py-3 rounded-full text-[12px] border-2 ".concat(sectionColor ? "" : "border-gray-200 dark:border-gray-600", " ").concat(getBorderClasses(sectionColor), " ").concat(getTextClasses(sectionColor)),
        style: getBorderStyle(sectionColor),
        title: shouldTruncate ? "".concat(field.tag, ": ").concat(fullValue) : undefined
      }, field.tag.length > 30 ? "".concat(field.tag.substring(0, 30), "...:") : "".concat(field.tag, ":"), " ", truncatedValue);
    })));
  }));
};
export default BulkPatientCard;